import React, { Suspense, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Themeroutes from './routes/Router';
import ThemeSelector from './layouts/theme/ThemeSelector';
import Loader from './layouts/loader/Loader';
import { b2cPolicies, checkTokenExpiry } from '../authConfig';
import { useMsal } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';

const compareIssuingPolicy = (idTokenClaims, policyName) => {
  return idTokenClaims.tfp === policyName;
};

function App() {
  const routing = useRoutes(Themeroutes);
  const direction = useSelector((state) => state.customizer.isRTL);
  const isMode = useSelector((state) => state.customizer.isDark);



  // Callback para gestionar redirecciones según la política de emisión
  // useEffect(() => {
  //   const callbackId = instance.addEventCallback((event) => {
  //     if (
  //       event.eventType === EventType.LOGIN_SUCCESS ||
  //       event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
  //     ) {
  //       if (event.payload.account) {
  //         // Si el token viene de la política SignUpSignIn
  //         if (compareIssuingPolicy(event.payload.idTokenClaims, b2cPolicies.names.signUpSignIn)) {
  //           const signUpSignInFlowRequest = {
  //             authority: b2cPolicies.authorities.signUpSignIn.authority,
  //             account: event.payload.account,
  //           };

  //           // Redirigir solo si no se está en el flujo signup
  //           if (!import.meta.location.href.includes("signup")) {
  //             instance.loginRedirect(signUpSignInFlowRequest).catch((error) => {
  //               console.error("Error al redirigir después del login:", error);
  //             });
  //           }
  //         }

  //         // Si el token viene de la política ForgotPassword
  //         if (compareIssuingPolicy(event.payload.idTokenClaims, b2cPolicies.names.forgotPassword)) {
  //           const resetPasswordRequest = {
  //             authority: b2cPolicies.authorities.forgotPassword.authority,
  //             scopes: [],
  //           };

  //           if (!import.meta.location.href.includes("resetpassword")) {
  //             instance.loginRedirect(resetPasswordRequest).catch((error) => {
  //               console.error("Error al redirigir al flujo de restablecimiento de contraseña:", error);
  //             });
  //           }
  //         }
  //       }
  //     }

  //     // Si el login falla y se detecta el error AADB2C90118, redirige al reset de contraseña
  //     if (event.eventType === EventType.LOGIN_FAILURE) {
  //       if (
  //         event.error &&
  //         event.error.errorMessage &&
  //         event.error.errorMessage.includes("AADB2C90118")
  //       ) {
  //         const resetPasswordRequest = {
  //           authority: b2cPolicies.authorities.forgotPassword.authority,
  //           scopes: [],
  //         };

  //         instance.loginRedirect(resetPasswordRequest).catch((error) => {
  //           console.error("Error al redirigir al flujo de restablecimiento de contraseña:", error);
  //         });
  //       }
  //     }
  //   });

  return (
    <Suspense fallback={<Loader />}>
      <div
        className={`${direction ? 'rtl' : 'ltr'} ${isMode ? 'dark' : ''}`}
        dir={direction ? 'rtl' : 'ltr'}
      >
        <ThemeSelector />
        {routing}
      </div>
    </Suspense>
  );
}

export default App;